/* @flow */

import * as React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import type {NutshellState} from '../../../../store';
import {closeSidebar} from './actions';
import {getIsOpen, getVisitorId} from './selectors';
import {VisitorsSidebar} from './visitors-sidebar';

export function VisitorsSidebarWrapper() {
    const isOpen = useSelector((state: NutshellState) => getIsOpen(state));
    const visitorId = useSelector((state: NutshellState) => getVisitorId(state));
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(closeSidebar());
    };

    if (!isOpen || !visitorId) {
        return null;
    }

    return <VisitorsSidebar visitorId={visitorId} onClose={handleClose} />;
}
